module.exports = __webpack_public_path__ + "static/media/ALTOeMPUJE.c9e4fff3.jpg";